import { useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Form, FormGroup, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker2";
import { useForm } from "react-hook-form";
import ModalProducts from "../../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../../store/api/SystemSettingsAPI";
import { addNewProductRequest, deleteProductRequestKala } from "../../store/api/ProductRequest";
import BihamtaTable from "../../../Components/BihamtaTable";
import { CheckLg, ExclamationTriangle, List, PlusLg, Save } from "react-bootstrap-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { invoiceTypes, keyIsLetterOrNumber, setErrorDialog } from "../../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { setDialog } from "../../store/api/GetAllProduct";

const ModalProductRequestFromService = (props) => {
    const { popData, setPopData } = props;
    const { show } = popData;
    const history = useHistory();
    const dispatch = useDispatch();
    const requestData = useRef({ StaffID: popData.StaffID });
    const [error, setError] = useState(null);
    const frmRequestDetails = useRef();
    const [requestDetails, setRequestDetails] = useState({ Data: [] });
    const [popProduct, setPopProduct] = useState({ show: false });
    const [selectedProduct, setSelectedProduct] = useState({});
    const { register, errors, handleSubmit } = useForm();

    const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const pDefaultSalePrice = Array.isArray(systemSettings ?? "") ? systemSettings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue : "";
    const pDefaultSalePriceLabel = Array.isArray(systemSettings ?? "") ? systemSettings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue : "";
    const pgType = Array.isArray(systemSettings ?? "") ? Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? "1") : 1;

    function close() {
        setPopData({
            show: false
        })
        setError(null);
        setRequestDetails({ Data: [] });
        requestData.current = {};
        setSelectedProduct({});
    }
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                setSelectedProduct(data);
            }
        }
        setPopProduct({ 
            show: true, 
            value: e.key, 
            setProductData: setData, 
            invoiceType: invoiceTypes.Purchase, 
            forPartRequest: true 
        });
        const inputCount = document.getElementById("requestProductCount");
        inputCount.focus();
    }
    const addSegment = (data) => {
        setError(null);
        if (requestDetails.Data.find(d => d.ProductID === selectedProduct.ProductID)) {
            setError("این قطعه در لیست وجود دارد");
            return;
        }
        let details = requestDetails.Data.slice();
        const item = {
            Index: details.length + 1,
            ProductID: selectedProduct.ProductID,
            ProductModel: selectedProduct.ProductModel,
            ProductName: selectedProduct.ProductName,
            Counts: data.Count ?? 1,
            Description: data.Description,
            IsGaurantee: data.IsGaurantee === true,
            SaleUnitPrice: selectedProduct.UnitPrice
        }
        setSelectedProduct({});
        frmRequestDetails.current.reset();
        details.push(item);
        setRequestDetails({ Data: details });

    };
    const deleteRow = (index, id) => {
        return () => {
            const deleteLocalRow = () => {
                let details = requestDetails.Data.filter(d => d.Index !== index);
                for (let i = 0; i < details.length; i++) {
                    details[i].Index = i + 1;
                }
                setRequestDetails({ Data: details });
            }
            if (id && id !== 0) {
                dispatch(deleteProductRequestKala(id, deleteLocalRow));
            }
            else {
                deleteLocalRow();
            }

        }
    }
    const onSubmit = () => {
        if ((popData?.StaffID ?? "") === '') {
            setError("تکنسین درخواست کننده مشخص نشده است");
            return;
        }
        if ((popData.ProductID ?? "") === "") {
            setError("محصول مورد نظر مشخص نشده است");
            return;
        }
        if (((requestData.current?.TypeAddress ?? "") === "")) {
            setError("نحوه ارسال مشخص نشده است");
            return;
        }
        if ((requestData.current?.RequestAddress ?? "") === "") {
            setError("نشانی محل ارسال مشخص نشده است");
            return;
        }
        if (!requestDetails?.Data || requestDetails.Data.length === 0) {
            setError("ردیفی برای درخواست وارد نشده است");
            return;
        }
        const productRequest = {
            ServiceID: popData.ServiceID,
            ServiceType: popData.ServiceType,
            ProductID: popData.ProductID,
            ProductSerial: popData.ProductSerial,
            CustomerID: popData.CustomerID,
            TypeAddress: requestData.current.TypeAddress,
            RequestAddress: requestData.current.RequestAddress,
            RequestDate: requestData.current.RequestDate,
            StaffID: popData.StaffID,
            SegmentList: requestDetails.Data,
            RequestAddress: requestData.current.RequestAddress,
            ServiceNumber: popData.ServiceNumber
        }
        const onSuccess = (segmentList, id) => {
            history.push(`/Services/PartRequest/${id}`);
        }
        dispatch(addNewProductRequest(productRequest, onSuccess));

    };
    function selectText(e) {
        e.target.select();
    }
    const tableCols = [
        { colTitle: "نام قطعه", colName: "ProductName" },
        { colTitle: "مدل قطعه", colName: "ProductModel" },
        { colTitle: "تعداد", colName: "Counts" },
        { colTitle: "توضیحات", colName: "Description" }
    ]
    const tableButtons = [
        {
            type: "delete", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف ردیف',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteRow(item.Index, item.ID)
                }))
            }
        }

    ]
    useEffect(() => {
        if (show) {
            requestData.current = { RequestAddress: popData.ServiceAddress, TypeAddress: 2, RequestDate: new Date() }
        }
    }, [show]);
    return (
        <Modal show={show} onHide={() => { }} size="lg">
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} defaultSalePrice={pDefaultSalePrice} defaultSalePriceLabel={pDefaultSalePriceLabel} />
            <Modal.Header className="headerStyle">
                <span>درخواست قطعه</span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle" size="xl" style={{ paddingTop: 4 }}>
                {error &&
                    <Alert variant="danger">
                        <ExclamationTriangle size={18} />&nbsp;
                        {error}
                        <FontAwesomeIcon icon={faTimes} size="lg" onClick={() => setError(null)} style={{ float: "left" }} />
                    </Alert>
                }
                <Row>
                    <Col md={3} className="form-group">
                        <label>تاریخ درخواست:</label>
                        <DatePicker isGregorian={false} timePicker={false} className="form-control"
                            onChange={value => requestData.current.RequestDate = value.local("en").format("YYYY-MM-DD")} />
                    </Col>
                    <Col md={4} className="form-group">
                        <label> نحوه ارسال </label>
                        <select className="form-control" onChange={e => requestData.current.TypeAddress = e.target.value} defaultValue={2}>
                            <option value={1}>ارسال به دفتر خدمات پس از فروش</option>
                            <option value={2}>ارسال به آدرس مشتری</option>
                        </select>
                    </Col>
                    <Col md={5} className="form-group">
                        <label> آدرس </label>
                        <input className="form-control" type="text" onChange={e => requestData.current.RequestAddress = e.target.value} defaultValue={popData.ServiceAddress ?? ""} />
                    </Col>
                </Row>
                <Row className="rowBorder mt-1">
                    <form readOnly onSubmit={handleSubmit(addSegment)} ref={frmRequestDetails}>
                        <Row>
                            <FormGroup className="form-group">
                                <input type="checkbox" ref={register({})} name="IsGaurantee" /><span style={{ color: "#d40f6a" }}>  قطعه گارانتی است&nbsp;&nbsp;</span>
                            </FormGroup>
                        </Row>
                        <Row>
                            <Col md={5} className="form-group">
                                <label>مشخصات قطعه</label>
                                <input type="hidden" value={selectedProduct?.ProductID ?? ""} readOnly ref={register({ required: true })} name="ProductID" />
                                <Form.Control name="ProductName" value={(selectedProduct?.ProductName ?? "") + "-" + (selectedProduct?.ProductModel ?? "")}
                                    readOnly onKeyDown={showModalProduct} /><span>&nbsp;</span>
                                <Button className="btn-input-tiny" onClick={showModalProduct} style={{ top: 26 }}><List size={21} /></Button>
                                {errors && errors.ProductID && <small className="errors">انتخاب کالا الزامی است</small>}
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تعداد</label>
                                <Form.Control id="requestProductCount" type="number" ref={register({ required: true })} name="Count" defaultValue={1} min={1} onFocus={selectText} />
                                {errors && errors.Count && <small className="errors">تعداد کالا الزامی است</small>}
                            </Col>
                            <Col className="form-group">
                                <label>توضیحات</label>
                                <Form.Control ref={register({})} name="Description" />
                            </Col>
                        </Row>
                        <Button type="submit" className="group-Btn mt-0"><PlusLg /> افزودن به لیست</Button>
                    </form>
                    <BihamtaTable columns={tableCols} rowButtons={tableButtons} fixedHeightTable dataList={requestDetails} />
                </Row>
                <div>
                    <Button className="group-Btn mt-1" onClick={onSubmit} variant="success"><CheckLg size={15} />  ثبت درخواست   </Button>
                </div>

            </Modal.Body>
        </Modal>
    )

}
export default ModalProductRequestFromService;